import { useSelector } from 'react-redux';
import { getIsZendeskInitedSelector, getZendeskTokenSelector } from '../zendeskSelectors';
import { getUserEmailSelector, getUserUidSelector } from '../../../app/appSelectors';
import { useEffect } from 'react';
import useZendeskWebWidgetInstance from "./useZendeskWebWidgetInstance";

export const useZendeskAuth = () => {
    const isInited = useSelector(getIsZendeskInitedSelector);
    const token = useSelector(getZendeskTokenSelector);
    const userEmail = useSelector(getUserEmailSelector);
    const uid = useSelector(getUserUidSelector);
    const zendeskWebWidgetInstance = useZendeskWebWidgetInstance();

    useEffect(() => {
        if (isInited) {
            if (token) {
                zendeskWebWidgetInstance.login({ email: userEmail, token, uid });
            } else {
                zendeskWebWidgetInstance.logout();
            }
        }
    }, [isInited, token, uid, userEmail, zendeskWebWidgetInstance]);
}
